import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class AccountService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
             ) { }


    getAccount() {
        return this.http.get(this.global.httpUrl+"accounts");
    }


    getBonusByFilter(filter: any[]) {
        let url = "";
        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }
        url = url.substring(0,url.length-1);
        return this.http.get(this.global.httpUrl + "accumulated-bonuses?" + url);
    }


    claculateBonus(id: string){
        return this.http.post(this.global.httpUrl+"accumulated-bonuses/charge-bonus",{contractor_id: id});
    }
    

    getAccountTransaction(id: any,page: number) {

        let url = "";
        if(page){
          url = "&page="+page;
        }

        return this.http.get(this.global.httpUrl+"accounts/transactions?account_id="+id+url);
    }

    getAccountTransactionByFilter(filter: any[],id:string,page: number) {

        let url = "";

        if(page){
            url = "&page="+page + "&";
        }

        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }

        url = url.substring(0,url.length-1);

        return this.http.get(this.global.httpUrl+"accounts/transactions?account_id="+id+url);
    }

    

      

    getTransactionTypeList() {
        return this.http.get(this.global.httpUrl+"transaction-types/for-replenishment");
    }

    getAccountTransactionPurposeTypeList() {
        return this.http.get(this.global.httpUrl+"account/account-transaction-purpose-type");
    }

   getAccountById(id: any) {
        return this.http.get(this.global.httpUrl+"accounts?accountable_id="+id);
    } 

    createAccount(data: any){
        return this.http.post(this.global.httpUrl+"accounts", data);
    }

    createAccountTransaction(data: any){
        return this.http.post(this.global.httpUrl+"accounts/replenishment", data);
    }
    
    updateAccountTransaction(data: any){
        return this.http.post(this.global.httpUrl+"accounts/transactions/change", data);
    }

   updateAccount(data: any,id: any){
        return this.http.put(this.global.httpUrl+"accounts/"+id, data);
    } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/accounts/account.service.ts